module.exports = __webpack_public_path__ + "media/images/athletes/1808-959fe404596e0a0c5ef86eb241637813.png";